module.exports = __webpack_public_path__ + "img/calendarIL.783a8790.jpg";